export const AnnouncementActionConst = {
  // List
  FETCH_ALL_ANNOUNCEMENTS_REQUEST: 'FETCH_ALL_ANNOUNCEMENTS_REQUEST',
  FETCH_ALL_ANNOUNCEMENTS_SUCC: 'FETCH_ALL_ANNOUNCEMENTS_SUCC',
  FETCH_ALL_ANNOUNCEMENTS_FAIL: 'FETCH_ALL_ANNOUNCEMENTS_FAIL',

  // Detail
  FETCH_ANNOUNCEMENT_DETAIL_REQUEST: 'FETCH_ANNOUNCEMENT_DETAIL_REQUEST',
  FETCH_ANNOUNCEMENT_DETAIL_SUCC: 'FETCH_ANNOUNCEMENT_DETAIL_SUCC',
  FETCH_ANNOUNCEMENT_DETAIL_FAIL: 'FETCH_ANNOUNCEMENT_DETAIL_FAIL',

  // Create
  CREATE_ANNOUNCEMENT_REQUEST: 'CREATE_ANNOUNCEMENT_REQUEST',
  CREATE_ANNOUNCEMENT_SUCC: 'CREATE_ANNOUNCEMENT_SUCC',
  CREATE_ANNOUNCEMENT_FAIL: 'CREATE_ANNOUNCEMENT_FAIL',

  // Update
  UPDATE_ANNOUNCEMENT_REQUEST: 'UPDATE_ANNOUNCEMENT_REQUEST',
  UPDATE_ANNOUNCEMENT_SUCC: 'UPDATE_ANNOUNCEMENT_SUCC',
  UPDATE_ANNOUNCEMENT_FAIL: 'UPDATE_ANNOUNCEMENT_FAIL',

  // Remove
  REMOVE_ANNOUNCEMENT_REQUEST: 'REMOVE_ANNOUNCEMENT_REQUEST',
  REMOVE_ANNOUNCEMENT_SUCC: 'REMOVE_ANNOUNCEMENT_SUCC',
  REMOVE_ANNOUNCEMENT_FAIL: 'REMOVE_ANNOUNCEMENT_FAIL',

  CLEAR_ANNOUNCEMENT_ACTION_STATE: 'CLEAR_ANNOUNCEMENT_ACTION_STATE',
};
